<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <DemoCharts msg="Welcome to Your Vue.js App"/>
</template>

<script>
import DemoCharts from './components/DemoCharts.vue';
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    DemoCharts
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: rgba(0, 0, 0, 0.032);
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
